//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-lazy-icon',
  props: {
    icon: {
      default: '',
      type: String,
    },
    text: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    onViewportIntersection(el, isIntercepting) {
      if (isIntercepting && !this.isVisible && this.icon) {
        this.isVisible = true
      }
    },
  },
}
